import { BookingCancellationEntryPoint } from "analytics";
import { BookingApplicationDate } from "helpers/booking-cancellation-helper";

export interface CancelBookingCreator {
  id?: string | null;
  name?: string | null;
  username?: string | null;
  avatarUrl?: string | null;
}

export interface CancelBookingRequestData {
  bookingId: string;
  collabId: string;
  entryPoint: BookingCancellationEntryPoint;
  applicationDate?: BookingApplicationDate;
  venueName?: string | null;
  venueAddress?: string | null;
  creator?: CancelBookingCreator | null;
}

interface CancelBookingSource {
  bookingId?: string | null;
  collabId?: string | null;
  foodieId?: string | null;
  name?: string | null;
  username?: string | null;
  avatarUrl?: string | null;
  applicationDate?: BookingApplicationDate;
  venue?: {
    name?: string | null;
    addressDisplay?: string | null;
    address?: string | null;
  } | null;
}

export const buildCancelBookingRequestData = (
  source: CancelBookingSource,
  entryPoint: BookingCancellationEntryPoint,
): CancelBookingRequestData | null => {
  const bookingId = source.bookingId ?? "";
  const collabId = source.collabId ?? "";

  if (!bookingId || !collabId) return null;

  return {
    bookingId,
    collabId,
    entryPoint,
    applicationDate: source.applicationDate,
    venueName: source.venue?.name ?? null,
    venueAddress: source.venue?.addressDisplay ?? source.venue?.address ?? null,
    creator: {
      id: source.foodieId ?? null,
      name: source.name ?? null,
      username: source.username ?? null,
      avatarUrl: source.avatarUrl ?? null,
    },
  };
};
